<div class="header-container">
    <div class="logo-container">
      @if (brokerId === '01') {
        <img src="assets/images/chill-logo.svg" alt="Chill Insurance Logo" class="logo logo-chill">
      } @else if (brokerId === '04') {
        <img src="assets/images/devil-logo.png" alt="Quote Devil Logo" class="logo logo-qd">
      }
    </div>
    <div class="header-links">
      <!-- <a href="#">Sitemap</a>
      <a href="#">Cookie Policy</a> -->
    </div>
  </div>

